import * as Sentry from '@sentry/react';
import { createFileRoute, redirect } from '@tanstack/react-router';

const storageKeysToKeep = ['app-theme', 'i18nextLng'];

export const Route = createFileRoute('/_authenticated/logout')({
  beforeLoad: async () => {
    const keys = Object.keys(window.localStorage);
    const keysToRemove = keys.filter((key) => !storageKeysToKeep.includes(key));
    keysToRemove.forEach((key) => {
      window.localStorage.removeItem(key);
    });

    Sentry.setUser(null);

    throw redirect({ to: '/login', reloadDocument: true });
  },
});
